module.exports = __webpack_public_path__ + "img/SES_Flatliner_I_Profiles.58aed8ee.jpg";